class WindowResize {
  constructor() {
    this.mobileMenu = document.getElementById("mobile-menu")
    this.desktopMenu = document.getElementById("desktop-menu")
    this.searchModal = document.getElementById("search-modal")

    // won't be present in microsites
    if (this.mobileMenu && this.desktopMenu && this.searchModal) {
      this.onResize()
      window.addEventListener("resize", this.onResize.bind(this))
    }
  }

  onResize() {
    if (this.isDesktop()) {
      this.desktopMenu.setAttribute("aria-hidden", false)
      this.mobileMenu.setAttribute("aria-hidden", true)
    } else {
      this.desktopMenu.setAttribute("aria-hidden", true)
      this.searchModal.setAttribute("aria-hidden", true)
    }
  }

  isDesktop() {
    return window.matchMedia("(min-width: 1200px)").matches
  }
}

export default WindowResize
